import api from '@/lib/api';
import type { PaginatedResponse } from '@pms/shared';
import type { MiscLedgerEntry } from './frontdeskOps.types';
import { MiscLedgerDirection, MiscLedgerCategory } from './frontdeskOps.types';

export interface ListMiscLedgerQuery {
  propertyId: string;
  direction: MiscLedgerDirection;
  from?: string | undefined;
  to?: string | undefined;
  category?: MiscLedgerCategory | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

export interface CreateMiscLedgerPayload {
  propertyId: string;
  direction: MiscLedgerDirection;
  category: MiscLedgerCategory;
  /** positive amount, >= 0.01 */
  amount: number;
  entryDate: string;
  note?: string | undefined;
}

export async function fetchMiscLedger(
  query: ListMiscLedgerQuery,
): Promise<PaginatedResponse<MiscLedgerEntry>> {
  const { data } = await api.get<PaginatedResponse<MiscLedgerEntry>>('/misc-ledger', {
    params: query,
  });
  return data;
}

export async function createMiscLedger(
  payload: CreateMiscLedgerPayload,
): Promise<MiscLedgerEntry> {
  const { data } = await api.post<MiscLedgerEntry>('/misc-ledger', payload);
  return data;
}
